import { Driver } from './driver.model';
import { DriverAction } from './enums/driver-action';
import { PageModel } from './page-model.model';
import { Page } from './page.model';
import { UnitShort } from './unit-short.model';

export class DriverHistory {

  constructor(public id: number,
              public unit: UnitShort,
              public driver: Driver,
              public time: string,
              public action: DriverAction,
              public active: boolean) {
  }

  public static valueOf(o: DriverHistory): DriverHistory {
    return o ? new DriverHistory(o.id, UnitShort.valueOf(o.unit), Driver.valueOf(o.driver), o.time, o.action, o.active) : null;
  }

  public static valuesOf(list: DriverHistory[]): DriverHistory[] {
    return list ? list.map(o => DriverHistory.valueOf(o)) : [];
  }

  public static pageableValueOf(o: Page<DriverHistory>): Page<DriverHistory> {
    return o ? new PageModel<DriverHistory>(o.empty, o.first, o.last, o.number, o.numberOfElements, o.totalElements, o.totalPages,
      o.urlParams, DriverHistory.valuesOf(o.content)) : null;
  }
}
